// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"9e39d9d7","535":"8b0e48f7","732":"99aec34f","857":"dd76b3d3","923":"02d78bdc"}[chunkId] + ".chunk.js";
};